import React from 'react';
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import TrackOrder from './pages/TrackOrder';
import { isPublicTrackingHost } from './utils/publicTracking';

function PublicApp() {
  const standalonePublicTracking = isPublicTrackingHost();
  const Router = standalonePublicTracking ? BrowserRouter : HashRouter;
  const fallbackPath = standalonePublicTracking ? '/' : '/track-order';

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {standalonePublicTracking && <Route path="/" element={<TrackOrder />} />}
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="*" element={<Navigate to={fallbackPath} replace />} />
      </Routes>
    </Router>
  );
}

export default PublicApp;
